<template>
  <BaseDetails class="base-details" v-if="booking && showSection">
    <template v-slot:header>
      <h2 class="pb-3">Internal Information</h2>
      <PrimaryButton
        v-if="canEdit"
        @click.native="openInternalInfoEdit"
        light
        dense
        shrink
        class="edit-button"
      >
        Edit
        <template v-slot:append:icon><v-icon>mdi-pencil</v-icon></template>
      </PrimaryButton>
    </template>

    <template v-slot:body>
      <EditInternalInfo
        v-if="isEditOpen"
        :internal-info="booking"
        :is-open="isEditOpen"
        @close="closeInternalInfoEdit"
      />
      <Permissioned section="bookings" :id="bookingId" vertical>
        <LabeledText label="Cost Code" permission="view.cost-centre">
          {{ costCodeWithClientName }}
        </LabeledText>
        <LabeledText label="Hiring Manager" permission="view.hiring-manager">
          <div>{{ booking.manager ? getFullName(booking.manager) : "-" }}</div>
        </LabeledText>
        <LabeledText label="Number of Vacancies" permission="view.vacancies">
          {{ booking.vacancies }}
        </LabeledText>
        <LabeledText label="Maximum Applications" permission="view.vacancies">
          {{ booking.maximumApplications || "-" }}
        </LabeledText>
        <LabeledText label="Reason for Hire" permission="view.reason-for-hire">
          {{ booking.hireReason }}
        </LabeledText>
        <LabeledText label="PO Number" permission="view.po-number">
          <div>{{ booking.poNumber ? booking.poNumber : "-" }}</div>
        </LabeledText>
        <LabeledText label="Post Number" permission="view.post-number">
          <div>{{ booking.postNumber ? booking.postNumber : "-" }}</div>
        </LabeledText>
        <LabeledText label="Apply Link" permission="view.apply-link-override">
          <div>{{ booking.applyLinkOverride || "-" }}</div>
        </LabeledText>
        <LabeledText
          label="Only Advertise Role Internally"
          permission="view.internal-only"
        >
          <Chip :color="booking.internalOnly ? 'green' : 'gray'">
            {{ booking.internalOnly ? "Yes" : "No" }}
            <v-icon class="ml-1" color="green" v-if="booking.internalOnly">
              mdi-check
            </v-icon>
          </Chip>
        </LabeledText>
        <LabeledText
          label="Anonymise Applications"
          permission="view.anonymise-applications"
        >
          <Chip :color="booking.anonymiseApplications ? 'green' : 'gray'">
            {{ booking.anonymiseApplications ? "Yes" : "No" }}
            <v-icon
              class="ml-1"
              color="green"
              v-if="booking.anonymiseApplications"
            >
              mdi-check
            </v-icon>
          </Chip>
        </LabeledText>
      </Permissioned>
      <v-divider />
    </template>
  </BaseDetails>
</template>

<script>
import LabeledText from "@/components/common/BaseDetails/LabeledText";
import BaseDetails from "@/components/common/BaseDetails/BaseDetails";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import EditInternalInfo from "@/views/bookings/EditBooking/EditInternalInfo";
import { createNamespacedHelpers } from "vuex";
import { BOOKINGS_NAMESPACE } from "@/store/modules/bookings/actions";
import Permissioned from "@/components/common/Permissioned";
import { getFullName } from "@/utils/users";
import { isPermissioned } from "@/utils/permissions";
import Chip from "@/components/common/Chip";
import { some } from "lodash";

const { mapState } = createNamespacedHelpers(BOOKINGS_NAMESPACE);

const INTERNAL_INFORMATION_PERMISSIONS = [
  "cost-centre",
  "hiring-manager",
  "vacancies",
  "reason-for-hire",
  "po-number",
  "post-number",
  "apply-link-override",
  "internal-only"
];

export default {
  name: "InternalInformation",
  components: {
    Permissioned,
    EditInternalInfo,
    PrimaryButton,
    LabeledText,
    BaseDetails,
    Chip
  },
  data() {
    return {
      isEditOpen: false
    };
  },
  computed: {
    ...mapState({
      currentBooking: state => state.currentBooking
    }),
    booking() {
      return this.currentBooking;
    },
    bookingId() {
      return this.booking.id;
    },
    costCodeWithClientName() {
      return this.booking.client
        ? `${this.booking.client.name} (${this.booking.costCode})`
        : this.booking.costCode;
    },
    canEdit() {
      return isPermissioned(`bookings[${this.bookingId}].edit`);
    },
    showSection() {
      return some(INTERNAL_INFORMATION_PERMISSIONS, permission => {
        return isPermissioned(`bookings[${this.bookingId}].view.${permission}`);
      });
    }
  },
  methods: {
    getFullName,
    openInternalInfoEdit() {
      this.isEditOpen = true;
    },
    closeInternalInfoEdit() {
      this.isEditOpen = false;
    }
  }
};
</script>
